export const FETCH_DRAFT_CANDIDATE = "FETCH_DRAFT_CANDIDATE";
export const SET_CANDIDATE_ID = "SET_CANDIDATE_ID";
export const SET_CANDIDATE_COUNTRY = "SET_CANDIDATE_COUNTRY";
export const DELETE_CANDIDATE_ID = "DELETE_CANDIDATE_ID";
export const DELETE_CANDIDATE_COUNTRY = "DELETE_CANDIDATE_COUNTRY";

export const DELETE_DRAFT_CANDIDATE = "DELETE_DRAFT_CANDIDATE";
export const DELETE_DRAFT_CANDIDATE_SUCCESS = "DELETE_DRAFT_CANDIDATE_SUCCESS";
export const DELETE_DRAFT_CANDIDATE_FAILURE = "DELETE_DRAFT_CANDIDATE_FAILURE";

export const CANDIDATE_REGISTRAION_RESET_META_DATA = "CANDIDATE_REGISTRAION_RESET_META_DATA";
